import $ from '../vendor/jquery';

$('#news-category-select').on('change', function () {
  $(this).closest('form').submit();
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/news.js